var track = require('@enhancer/fe-error-track');
track('user-center-assets', '', function (data) {
	window.handleEnhancerError && window.handleEnhancerError(data);
});






// WEBPACK FOOTER //
// ./src/app/app.js